import { Component, OnDestroy, OnInit } from '@angular/core';
import { PanelList } from '../../../../shared/models/panel-list';
import { DelegationService } from '../../../../delegate-slider/services/delegation.service';
import { DelegateDtoDisplay } from '../../../models/delegateDtoDisplay';
import { DocumentDisplayInformation } from '../../../../delegate-slider/models/documentDisplayInformation';
import { DelegationLibraryConstants } from '../../../../delegate/delegation-library-constants';
import { catchError, Subject, takeUntil, throwError, skip } from 'rxjs';
import { MessageService } from 'primeng/api';
import { DelegationInteractionService } from '../../../../delegate-slider/services/delegation-interaction-service';

@Component({
  selector: 'app-delegated-to-me',
  templateUrl: './delegated-to-me.component.html',
  styleUrls: ['./delegated-to-me.component.scss']
})
export class DelegatedToMeComponent implements OnInit, OnDestroy {
  ismyDelegationsDataAvailable: boolean = false;
  isActiveDelegatesInDelegatedToMe: boolean = true;
  docNumberList: any[] = [];
  myDelegationsData: PanelList = {
    lists: [],
    filters: [],
    sort: [],
    enableFilter: false,
    enableSort: false,
  };
  documentDetailInformation: DocumentDisplayInformation[] = [];
  myDelegations: DelegateDtoDisplay[] = [];
  showInactiveCheckBoxClicked = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  showLoader : boolean = true;
  firstLoad = true;
  showPanelLoader = false;

  constructor(
    private delegationService: DelegationService,
    private messageService: MessageService,
    private delegationInteractionService: DelegationInteractionService
  ) {}

  ngOnInit(): void {
    this.getDelegations(); // initial load
    this.delegationInteractionService.saveDelegation$.pipe(takeUntil(this.destroy$), skip(1)).subscribe(
      (isClose) => {
          this.getDelegations();        
      }
    );
  }

  getDelegations() {
    if (!this.firstLoad)
    this.showPanelLoader = true;
    this.delegationService
      .getDelegationsForMeTab(this.isActiveDelegatesInDelegatedToMe).pipe(catchError((err) => {
        this.messageService.add({severity:DelegationLibraryConstants.Severity_Err, summary:`${DelegationLibraryConstants.Get_Delegations_Failure}`});
        this.firstLoad? this.showLoader = false: this.showPanelLoader = false;
        return throwError((() => err));
      }),takeUntil(this.destroy$))
      .subscribe((delegations) => {
        this.myDelegationsData.lists = delegations;
        this.myDelegations = delegations;
        this.constructDataForDisplay();
        this.firstLoad? this.showLoader = false: this.showPanelLoader = false;
      });
    this.addFilters();
    this.addSorting();
  }

  constructDataForDisplay() {
    this.myDelegations
      .map((del) => del.documentNumbers)
      .forEach((docNumber) => {
        if (docNumber != null) {
          docNumber.forEach((number) => {
            if (!this.docNumberList.includes(number) && number != null) {
              this.docNumberList.push(number);
            }
          });
        }
      });
    if(this.docNumberList && this.docNumberList.length > 0){
    this.delegationService
      .getLatestDocumentDetail(this.docNumberList).pipe(catchError((err) => {
        this.messageService.add({severity:DelegationLibraryConstants.Severity_Err, summary:`${DelegationLibraryConstants.Get_Document_Titles_Failure}`});
        return throwError((() => err));
      }),takeUntil(this.destroy$))
      .subscribe((linkedItemDisplay) => {
        this.documentDetailInformation = linkedItemDisplay;
        this.myDelegations.forEach((delegate) => {
          if (delegate.scopeName == 'Document') {
            delegate.documentDisplayInformations = [];
            this.documentDetailInformation.forEach((documentDetail) => {
              delegate.documentNumbers.forEach((docNumber) => {
                if (docNumber != null) {
                  if (documentDetail.number == docNumber) {
                    delegate.documentDisplayInformations?.push(documentDetail);
                  }
                }
              });
            });
          }
        });
        this.ismyDelegationsDataAvailable = true;
        this.myDelegationsData = {...this.myDelegationsData};
      });
    }
    else {
      this.ismyDelegationsDataAvailable = true;
      this.myDelegationsData = {...this.myDelegationsData};
    }
  }

  addFilters() {
    this.myDelegationsData.filters = [];
    this.myDelegationsData.enableFilter = true;
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Scope',
      filterFieldName: 'scopeName',
    });
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Assignment',
      filterFieldName: 'assignmentNames',
    });
    this.myDelegationsData.filters?.push({
      filterDisplayName: 'Delegated From',
      filterFieldName: 'delegateFrom',
    });
  }

  addSorting() {
    this.myDelegationsData.sort = [];
    this.myDelegationsData.enableSort = true;
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Scope',
      sortFieldName: 'scopeName',
    });
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Assignment',
      sortFieldName: 'assignmentNames',
    });
    this.myDelegationsData.sort?.push({
      sortFieldDisplayName: 'Delegated From',
      sortFieldName: 'delegateFrom',
    });
  }

  showInactiveDelegates() {
    this.firstLoad = false;
    this.isActiveDelegatesInDelegatedToMe = !this.isActiveDelegatesInDelegatedToMe;
    this.getDelegations();
  }
  
  ngOnDestroy = () => {
    this.destroy$.next(true);
    this.destroy$.unsubscribe(); 
   }
}
